namespace Matrix.Indexation {
    export interface IndexPriceForm {
        IndexationProfileCode: Serenity.StringEditor;
        IndexCode: Serenity.StringEditor;
        PriceTypeCode: Serenity.StringEditor;
        PriceDate: Serenity.DateEditor;
        IndexPrice: Serenity.DecimalEditor;
        SourceCode: Serenity.StringEditor;
        IndexPriceCurrency: Serenity.StringEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class IndexPriceForm extends Serenity.PrefixedContext {
        static formKey = 'Indexation.IndexPrice';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!IndexPriceForm.init)  {
                IndexPriceForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = s.DecimalEditor;
                var w3 = StaticTextBlock;
                var w4 = ReadOnlyDateTime;

                Q.initFormType(IndexPriceForm, [
                    'IndexationProfileCode', w0,
                    'IndexCode', w0,
                    'PriceTypeCode', w0,
                    'PriceDate', w1,
                    'IndexPrice', w2,
                    'SourceCode', w0,
                    'IndexPriceCurrency', w0,
                    'CreatedBy', w3,
                    'CreatedWhen', w4,
                    'UpdatedBy', w3,
                    'UpdatedWhen', w4,
                    'Version', w3
                ]);
            }
        }
    }
}
